/**
 * GENERATED by script/gen-sprites.mjs. DO NOT EDIT.
 *
 * ⚠ ADMIN ONLY. Carries the English developer labels and the picker grouping,
 * which is why it is not in the shared tree. The runtime half is
 * extensions/src/core/catalog.gen.ts and contains no strings a merchant reads.
 */
export interface AdminEffect {
  label: string;
  group: string;
  family: string;
  pack: string;
  sprites: string[];
  colors: string[];
  baseCount: number;
  params: Record<string, unknown>;
}

export const EFFECT_CATALOG: Record<string, AdminEffect> = {
  "snow.classic": {
    "label": "Classic snow",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "flake.6",
      "flake.6.fine",
      "flake.8"
    ],
    "colors": [
      "#FFFFFF",
      "#E8F4FF"
    ],
    "baseCount": 180,
    "params": {
      "preset": "snow"
    }
  },
  "snow.soft": {
    "label": "Soft snow",
    "group": "winter",
    "family": "fall",
    "pack": "core",
    "sprites": [
      "dot.sm",
      "dot.md"
    ],
    "colors": [
      "#FFFFFF"
    ],
    "baseCount": 150,
    "params": {
      "preset": "snow"
    }
  },
  "snow.heavy": {
    "label": "Heavy snow",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "flake.6.bold",
      "flake.6",
      "snowball"
    ],
    "colors": [
      "#FFFFFF",
      "#E8F4FF"
    ],
    "baseCount": 240,
    "params": {
      "preset": "snow"
    }
  },
  "snow.sparkle": {
    "label": "Sparkling snow",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "flake.star",
      "flake.6.fine"
    ],
    "colors": [
      "#FFFFFF",
      "#BFD8F0"
    ],
    "baseCount": 160,
    "params": {
      "preset": "snow"
    }
  },
  "snow.blizzard": {
    "label": "Blizzard",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "flake.6.fine",
      "snowball"
    ],
    "colors": [
      "#FFFFFF",
      "#E8F4FF"
    ],
    "baseCount": 300,
    "params": {
      "preset": "snow"
    }
  },
  "icicles.fall": {
    "label": "Falling icicles",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "icicle"
    ],
    "colors": [
      "#BFD8F0",
      "#FFFFFF"
    ],
    "baseCount": 90,
    "params": {
      "preset": "rain"
    }
  },
  "baubles.fall": {
    "label": "Falling baubles",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "bauble",
      "bell"
    ],
    "colors": [
      "#C24A1E",
      "#FFC93C",
      "#3FC9DE"
    ],
    "baseCount": 70,
    "params": {
      "preset": "coins"
    }
  },
  "gifts.fall": {
    "label": "Falling gifts",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "gift",
      "candycane"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE"
    ],
    "baseCount": 60,
    "params": {
      "preset": "coins"
    }
  },
  "holly.fall": {
    "label": "Holly and fir",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "holly",
      "tree"
    ],
    "colors": [
      "#2F8F4E",
      "#C24A1E"
    ],
    "baseCount": 80,
    "params": {
      "preset": "leaves"
    }
  },
  "mittens.fall": {
    "label": "Falling mittens",
    "group": "winter",
    "family": "fall",
    "pack": "winter",
    "sprites": [
      "mitten"
    ],
    "colors": [
      "#C24A1E",
      "#3FC9DE"
    ],
    "baseCount": 60,
    "params": {
      "preset": "leaves"
    }
  },
  "rain.classic": {
    "label": "Rain",
    "group": "weather",
    "family": "fall",
    "pack": "core",
    "sprites": [
      "drop.rain"
    ],
    "colors": [
      "#BFD8F0"
    ],
    "baseCount": 220,
    "params": {
      "preset": "rain"
    }
  },
  "rain.heavy": {
    "label": "Heavy rain",
    "group": "weather",
    "family": "fall",
    "pack": "core",
    "sprites": [
      "drop.rain",
      "drop.wide"
    ],
    "colors": [
      "#8FB8DC"
    ],
    "baseCount": 320,
    "params": {
      "preset": "rain"
    }
  },
  "rain.spring": {
    "label": "Spring shower",
    "group": "weather",
    "family": "fall",
    "pack": "spring",
    "sprites": [
      "raindrop"
    ],
    "colors": [
      "#3FC9DE",
      "#BFD8F0",
      "#FFFFFF"
    ],
    "baseCount": 180,
    "params": {
      "preset": "rain"
    }
  },
  "leaves.autumn": {
    "label": "Autumn leaves",
    "group": "autumn",
    "family": "fall",
    "pack": "autumn",
    "sprites": [
      "leaf.a",
      "leaf.b"
    ],
    "colors": [
      "#E07A2B",
      "#C24A1E",
      "#E8B23A"
    ],
    "baseCount": 90,
    "params": {
      "preset": "leaves"
    }
  },
  "leaves.maple": {
    "label": "Maple leaves",
    "group": "autumn",
    "family": "fall",
    "pack": "autumn",
    "sprites": [
      "leaf.b"
    ],
    "colors": [
      "#C24A1E",
      "#E07A2B"
    ],
    "baseCount": 80,
    "params": {
      "preset": "leaves"
    }
  },
  "leaves.oak": {
    "label": "Oak and acorns",
    "group": "autumn",
    "family": "fall",
    "pack": "autumn",
    "sprites": [
      "leaf.oak",
      "acorn"
    ],
    "colors": [
      "#8A5A2B",
      "#E8B23A"
    ],
    "baseCount": 80,
    "params": {
      "preset": "leaves"
    }
  },
  "harvest.fall": {
    "label": "Harvest",
    "group": "autumn",
    "family": "fall",
    "pack": "autumn",
    "sprites": [
      "wheat",
      "pinecone",
      "mushroom"
    ],
    "colors": [
      "#C8922E",
      "#8A5A2B"
    ],
    "baseCount": 70,
    "params": {
      "preset": "leaves"
    }
  },
  "feathers.fall": {
    "label": "Feathers",
    "group": "autumn",
    "family": "fall",
    "pack": "autumn",
    "sprites": [
      "feather"
    ],
    "colors": [
      "#C8922E",
      "#F5F7FA"
    ],
    "baseCount": 60,
    "params": {
      "preset": "petals"
    }
  },
  "petals.sakura": {
    "label": "Cherry blossom",
    "group": "spring",
    "family": "fall",
    "pack": "spring",
    "sprites": [
      "petal.cherry",
      "petal.a"
    ],
    "colors": [
      "#FFC2D6",
      "#FFE1EA"
    ],
    "baseCount": 110,
    "params": {
      "preset": "petals"
    }
  },
  "petals.rose": {
    "label": "Rose petals",
    "group": "spring",
    "family": "fall",
    "pack": "romance",
    "sprites": [
      "heart.small"
    ],
    "colors": [
      "#FF4F87",
      "#FF8AB0"
    ],
    "baseCount": 100,
    "params": {
      "preset": "petals"
    }
  },
  "blossom.fall": {
    "label": "Falling blossom",
    "group": "spring",
    "family": "fall",
    "pack": "spring",
    "sprites": [
      "blossom.5",
      "blossom.6"
    ],
    "colors": [
      "#FFC2D6",
      "#FFE1EA"
    ],
    "baseCount": 100,
    "params": {
      "preset": "petals"
    }
  },
  "daisies.fall": {
    "label": "Daisies",
    "group": "spring",
    "family": "fall",
    "pack": "spring",
    "sprites": [
      "daisy.8",
      "blossom.5"
    ],
    "colors": [
      "#FFFFFF",
      "#FFC93C"
    ],
    "baseCount": 90,
    "params": {
      "preset": "petals"
    }
  },
  "eggs.fall": {
    "label": "Easter eggs",
    "group": "spring",
    "family": "fall",
    "pack": "spring",
    "sprites": [
      "egg"
    ],
    "colors": [
      "#FFC2D6",
      "#3FC9DE",
      "#FFC93C"
    ],
    "baseCount": 70,
    "params": {
      "preset": "coins"
    }
  },
  "clover.fall": {
    "label": "Shamrocks",
    "group": "spring",
    "family": "fall",
    "pack": "spring",
    "sprites": [
      "clover"
    ],
    "colors": [
      "#2F8F4E",
      "#5BBE7A"
    ],
    "baseCount": 90,
    "params": {
      "preset": "leaves"
    }
  },
  "tulips.fall": {
    "label": "Tulips",
    "group": "spring",
    "family": "fall",
    "pack": "spring",
    "sprites": [
      "tulip"
    ],
    "colors": [
      "#FF4F87",
      "#FFC93C"
    ],
    "baseCount": 70,
    "params": {
      "preset": "petals"
    }
  },
  "hearts.fall": {
    "label": "Falling hearts",
    "group": "romance",
    "family": "fall",
    "pack": "romance",
    "sprites": [
      "heart.solid"
    ],
    "colors": [
      "#FF4F87",
      "#FF8AB0"
    ],
    "baseCount": 90,
    "params": {
      "preset": "hearts"
    }
  },
  "hearts.outline": {
    "label": "Outlined hearts",
    "group": "romance",
    "family": "fall",
    "pack": "romance",
    "sprites": [
      "heart.outline",
      "heart.small"
    ],
    "colors": [
      "#FF4F87",
      "#FF8AB0"
    ],
    "baseCount": 90,
    "params": {
      "preset": "hearts"
    }
  },
  "hearts.sparkle": {
    "label": "Sparkling hearts",
    "group": "romance",
    "family": "fall",
    "pack": "romance",
    "sprites": [
      "sparkle.heart",
      "heart.small"
    ],
    "colors": [
      "#FF4F87",
      "#FFC93C"
    ],
    "baseCount": 80,
    "params": {
      "preset": "hearts"
    }
  },
  "kisses.fall": {
    "label": "Kisses",
    "group": "romance",
    "family": "fall",
    "pack": "romance",
    "sprites": [
      "kiss",
      "heart.small"
    ],
    "colors": [
      "#FF4F87",
      "#FF8AB0"
    ],
    "baseCount": 70,
    "params": {
      "preset": "hearts"
    }
  },
  "letters.fall": {
    "label": "Love letters",
    "group": "romance",
    "family": "fall",
    "pack": "romance",
    "sprites": [
      "envelope",
      "heart.small"
    ],
    "colors": [
      "#FF4F87",
      "#FFF3E0"
    ],
    "baseCount": 60,
    "params": {
      "preset": "hearts"
    }
  },
  "roses.fall": {
    "label": "Roses",
    "group": "romance",
    "family": "fall",
    "pack": "romance",
    "sprites": [
      "rose"
    ],
    "colors": [
      "#D42A55",
      "#FF8AB0"
    ],
    "baseCount": 70,
    "params": {
      "preset": "petals"
    }
  },
  "confetti.fall": {
    "label": "Falling confetti",
    "group": "party",
    "family": "fall",
    "pack": "core",
    "sprites": [
      "confetto.a",
      "confetto.b"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE"
    ],
    "baseCount": 160,
    "params": {
      "preset": "confetti"
    }
  },
  "confetti.strips": {
    "label": "Confetti strips",
    "group": "party",
    "family": "fall",
    "pack": "core",
    "sprites": [
      "confetto.long",
      "confetto.a"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE"
    ],
    "baseCount": 150,
    "params": {
      "preset": "confetti"
    }
  },
  "stars.twinkle": {
    "label": "Twinkling stars",
    "group": "party",
    "family": "fall",
    "pack": "core",
    "sprites": [
      "star.5",
      "sparkle.4"
    ],
    "colors": [
      "#FFC93C",
      "#FFF3E0"
    ],
    "baseCount": 120,
    "params": {
      "preset": "confetti"
    }
  },
  "stars.slow": {
    "label": "Drifting stars",
    "group": "party",
    "family": "fall",
    "pack": "core",
    "sprites": [
      "star.6",
      "sparkle.slim"
    ],
    "colors": [
      "#FFF3E0",
      "#3FC9DE"
    ],
    "baseCount": 90,
    "params": {
      "preset": "snow"
    }
  },
  "coins.fall": {
    "label": "Falling coins",
    "group": "party",
    "family": "fall",
    "pack": "celebration",
    "sprites": [
      "coin.a"
    ],
    "colors": [
      "#FFC93C",
      "#E8A317"
    ],
    "baseCount": 80,
    "params": {
      "preset": "coins"
    }
  },
  "coins.rain": {
    "label": "Money rain",
    "group": "party",
    "family": "fall",
    "pack": "celebration",
    "sprites": [
      "coin.a",
      "coin.stack"
    ],
    "colors": [
      "#FFC93C",
      "#E8A317"
    ],
    "baseCount": 130,
    "params": {
      "preset": "coins"
    }
  },
  "balloons.fall": {
    "label": "Falling balloons",
    "group": "party",
    "family": "fall",
    "pack": "celebration",
    "sprites": [
      "balloon"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE"
    ],
    "baseCount": 60,
    "params": {
      "preset": "petals"
    }
  },
  "cupcakes.fall": {
    "label": "Treats",
    "group": "party",
    "family": "fall",
    "pack": "celebration",
    "sprites": [
      "cupcake",
      "champagne"
    ],
    "colors": [
      "#FF8AB0",
      "#FFC93C"
    ],
    "baseCount": 60,
    "params": {
      "preset": "coins"
    }
  },
  "tags.fall": {
    "label": "Sale tags",
    "group": "party",
    "family": "fall",
    "pack": "celebration",
    "sprites": [
      "tag"
    ],
    "colors": [
      "#FF4F87",
      "#FFC93C"
    ],
    "baseCount": 70,
    "params": {
      "preset": "leaves"
    }
  },
  "bats.fall": {
    "label": "Bats",
    "group": "spooky",
    "family": "fall",
    "pack": "spooky",
    "sprites": [
      "bat"
    ],
    "colors": [
      "#1A1330",
      "#8B5CF6"
    ],
    "baseCount": 70,
    "params": {
      "preset": "leaves"
    }
  },
  "ghosts.fall": {
    "label": "Ghosts",
    "group": "spooky",
    "family": "fall",
    "pack": "spooky",
    "sprites": [
      "ghost"
    ],
    "colors": [
      "#F5F7FA",
      "#BFD8F0"
    ],
    "baseCount": 50,
    "params": {
      "preset": "snow"
    }
  },
  "pumpkins.fall": {
    "label": "Pumpkins",
    "group": "spooky",
    "family": "fall",
    "pack": "spooky",
    "sprites": [
      "pumpkin"
    ],
    "colors": [
      "#FF8A14",
      "#E07A2B"
    ],
    "baseCount": 60,
    "params": {
      "preset": "coins"
    }
  },
  "spooky.mix": {
    "label": "Halloween mix",
    "group": "spooky",
    "family": "fall",
    "pack": "spooky",
    "sprites": [
      "ghost",
      "bat",
      "pumpkin",
      "skull"
    ],
    "colors": [
      "#FF8A14",
      "#8B5CF6",
      "#F5F7FA"
    ],
    "baseCount": 80,
    "params": {
      "preset": "leaves"
    }
  },
  "spiders.fall": {
    "label": "Spiders",
    "group": "spooky",
    "family": "fall",
    "pack": "spooky",
    "sprites": [
      "spider",
      "web"
    ],
    "colors": [
      "#1A1330",
      "#F5F7FA"
    ],
    "baseCount": 60,
    "params": {
      "preset": "snow"
    }
  },
  "candy.fall": {
    "label": "Trick or treat",
    "group": "spooky",
    "family": "fall",
    "pack": "spooky",
    "sprites": [
      "candy",
      "potion"
    ],
    "colors": [
      "#FF8A14",
      "#8B5CF6",
      "#F5F7FA"
    ],
    "baseCount": 80,
    "params": {
      "preset": "coins"
    }
  },
  "moons.fall": {
    "label": "Cats and moons",
    "group": "spooky",
    "family": "fall",
    "pack": "spooky",
    "sprites": [
      "moon.crescent",
      "cat"
    ],
    "colors": [
      "#FFC93C",
      "#1A1330"
    ],
    "baseCount": 50,
    "params": {
      "preset": "snow"
    }
  },
  "summer.beach": {
    "label": "Beach day",
    "group": "summer",
    "family": "fall",
    "pack": "summer",
    "sprites": [
      "shell",
      "beachball",
      "sunglasses"
    ],
    "colors": [
      "#3FC9DE",
      "#BFD8F0",
      "#FFFFFF"
    ],
    "baseCount": 60,
    "params": {
      "preset": "leaves"
    }
  },
  "summer.tropical": {
    "label": "Tropical",
    "group": "summer",
    "family": "fall",
    "pack": "summer",
    "sprites": [
      "palm",
      "watermelon",
      "icecream"
    ],
    "colors": [
      "#2F8F4E",
      "#FF4F87"
    ],
    "baseCount": 60,
    "params": {
      "preset": "leaves"
    }
  },
  "sun.rays": {
    "label": "Sunshine",
    "group": "summer",
    "family": "fall",
    "pack": "summer",
    "sprites": [
      "sunray",
      "sun"
    ],
    "colors": [
      "#FFC93C",
      "#FF8A14"
    ],
    "baseCount": 70,
    "params": {
      "preset": "snow"
    }
  },
  "burst.cannon": {
    "label": "Confetti cannon",
    "group": "party",
    "family": "burst",
    "pack": "core",
    "sprites": [
      "confetto.a",
      "confetto.b",
      "confetto.long"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE"
    ],
    "baseCount": 160,
    "params": {
      "preset": "cannon"
    }
  },
  "burst.popper": {
    "label": "Party popper",
    "group": "party",
    "family": "burst",
    "pack": "core",
    "sprites": [
      "confetto.a",
      "star.5"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE"
    ],
    "baseCount": 140,
    "params": {
      "preset": "popper"
    }
  },
  "burst.firework": {
    "label": "Fireworks",
    "group": "party",
    "family": "burst",
    "pack": "celebration",
    "sprites": [
      "firework"
    ],
    "colors": [
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE"
    ],
    "baseCount": 180,
    "params": {
      "preset": "firework"
    }
  },
  "burst.sparkle": {
    "label": "Sparkle burst",
    "group": "party",
    "family": "burst",
    "pack": "core",
    "sprites": [
      "sparkle.4",
      "star.4"
    ],
    "colors": [
      "#FFC93C",
      "#FFF3E0"
    ],
    "baseCount": 120,
    "params": {
      "preset": "sparkle"
    }
  },
  "burst.coins": {
    "label": "Coin burst",
    "group": "party",
    "family": "burst",
    "pack": "celebration",
    "sprites": [
      "coin.a"
    ],
    "colors": [
      "#FFC93C",
      "#E8A317"
    ],
    "baseCount": 120,
    "params": {
      "preset": "coins"
    }
  },
  "burst.hearts": {
    "label": "Heart burst",
    "group": "romance",
    "family": "burst",
    "pack": "romance",
    "sprites": [
      "heart.solid",
      "heart.small"
    ],
    "colors": [
      "#FF4F87",
      "#FF8AB0"
    ],
    "baseCount": 120,
    "params": {
      "preset": "popper"
    }
  },
  "rise.bubbles": {
    "label": "Bubbles",
    "group": "summer",
    "family": "rise",
    "pack": "core",
    "sprites": [
      "bubble",
      "ring.thin"
    ],
    "colors": [
      "#3FC9DE",
      "#BFD8F0",
      "#FFFFFF"
    ],
    "baseCount": 90,
    "params": {
      "preset": "bubbles"
    }
  },
  "rise.balloons": {
    "label": "Rising balloons",
    "group": "party",
    "family": "rise",
    "pack": "celebration",
    "sprites": [
      "balloon"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE"
    ],
    "baseCount": 40,
    "params": {
      "preset": "balloons"
    }
  },
  "rise.lanterns": {
    "label": "Sky lanterns",
    "group": "cultural",
    "family": "rise",
    "pack": "celebration",
    "sprites": [
      "lantern"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C"
    ],
    "baseCount": 35,
    "params": {
      "preset": "lanterns"
    }
  },
  "rise.embers": {
    "label": "Embers",
    "group": "autumn",
    "family": "rise",
    "pack": "core",
    "sprites": [
      "dot.sm",
      "sparkle.4"
    ],
    "colors": [
      "#FF8A14",
      "#FFC93C"
    ],
    "baseCount": 120,
    "params": {
      "preset": "embers"
    }
  },
  "rise.butterflies": {
    "label": "Butterflies",
    "group": "spring",
    "family": "rise",
    "pack": "spring",
    "sprites": [
      "butterfly"
    ],
    "colors": [
      "#FF8A14",
      "#3FC9DE",
      "#FF4F87"
    ],
    "baseCount": 45,
    "params": {
      "preset": "butterflies"
    }
  },
  "rise.hearts": {
    "label": "Rising hearts",
    "group": "romance",
    "family": "rise",
    "pack": "romance",
    "sprites": [
      "heart.small",
      "sparkle.heart"
    ],
    "colors": [
      "#FF4F87",
      "#FF8AB0"
    ],
    "baseCount": 70,
    "params": {
      "preset": "bubbles"
    }
  },
  "flash.distant": {
    "label": "Distant lightning",
    "group": "weather",
    "family": "flash",
    "pack": "core",
    "sprites": [
      "dot.sm"
    ],
    "colors": [
      "#DCE9FF"
    ],
    "baseCount": 0,
    "params": {
      "preset": "distant"
    }
  },
  "flash.storm": {
    "label": "Thunderstorm",
    "group": "weather",
    "family": "flash",
    "pack": "core",
    "sprites": [
      "dot.sm"
    ],
    "colors": [
      "#FFFFFF"
    ],
    "baseCount": 0,
    "params": {
      "preset": "storm"
    }
  },
  "flash.camera": {
    "label": "Camera flash",
    "group": "party",
    "family": "flash",
    "pack": "core",
    "sprites": [
      "dot.sm"
    ],
    "colors": [
      "#FFF6D8"
    ],
    "baseCount": 0,
    "params": {
      "preset": "paparazzi"
    }
  },
  "decor.corners": {
    "label": "Corner decorations",
    "group": "winter",
    "family": "static",
    "pack": "winter",
    "sprites": [
      "holly",
      "tree"
    ],
    "colors": [
      "#2F8F4E",
      "#C24A1E"
    ],
    "baseCount": 0,
    "params": {
      "preset": "corners"
    }
  },
  "decor.garland": {
    "label": "Garland",
    "group": "winter",
    "family": "static",
    "pack": "winter",
    "sprites": [
      "holly",
      "bauble"
    ],
    "colors": [
      "#2F8F4E",
      "#C24A1E"
    ],
    "baseCount": 0,
    "params": {
      "preset": "garland"
    }
  },
  "decor.lights": {
    "label": "String lights",
    "group": "party",
    "family": "static",
    "pack": "core",
    "sprites": [
      "dot.md"
    ],
    "colors": [
      "#FFC93C",
      "#FF4F87",
      "#3FC9DE",
      "#5BBE7A"
    ],
    "baseCount": 0,
    "params": {
      "preset": "lights"
    }
  },
  "decor.spooky": {
    "label": "Cobweb corners",
    "group": "spooky",
    "family": "static",
    "pack": "spooky",
    "sprites": [
      "web",
      "bat"
    ],
    "colors": [
      "#F5F7FA",
      "#1A1330"
    ],
    "baseCount": 0,
    "params": {
      "preset": "corners-all"
    }
  },
  "decor.spring": {
    "label": "Blossom corners",
    "group": "spring",
    "family": "static",
    "pack": "spring",
    "sprites": [
      "blossom.5",
      "butterfly"
    ],
    "colors": [
      "#FFC2D6",
      "#FFE1EA"
    ],
    "baseCount": 0,
    "params": {
      "preset": "corners"
    }
  }
};

export const EFFECT_GROUPS = ["winter","weather","autumn","spring","romance","party","spooky","summer","cultural"] as const;

export const EFFECT_COUNT = 70;
